import { gql } from '@apollo/client';
import { EMAIL_TEMPLATE_FIELDS } from './EmailTemplate.fragment';
import { SITE_FIELDS } from './Site.fragment';

export const HOME_OF_THE_WEEK_FIELDS = gql`
  ${SITE_FIELDS}
  ${EMAIL_TEMPLATE_FIELDS}
  fragment HomeOfTheWeekFields on emailHomeOfTheWeek {
    id
    banner2Alt
    banner2ImageUrl
    banner2Url
    bannerAlt
    bannerImageUrl
    bannerUrl
    emailTemplateId
    introduction
    listingButtonText
    listingUrl
    isSent
    isScheduled
    mailchimpCampaignId
    utm
    sendDate
    sendTime
    siteId
    slots
    style
    subject
    site {
      ...SiteFields
    }
    emailTemplate {
      ...EmailTemplateFields
    }
  }
`;
